import { h, render, Component } from 'preact';

import Fab from 'q-mdc/elements/material-fab';
import List from 'q-mdc/elements/material-list';
import ListItem from 'q-mdc/elements/material-list-item';
import Footer from 'q-mdc/elements/material-footer';

import { Facebook, Linkedin, Twitter, Youtube } from '../icons/socialIcons';
import showOrHide from '../hoc/showOrHide';
import {getEventTrackGA} from '../../helpers/ga';

// The below css is coming from q-mdc - Shahab
// import styles from './index.scss';

class FooterToolbar extends Component {
	state = { currentYear: (new Date()).getFullYear() };


	pushGa = (gaEvent) => {
		getEventTrackGA(gaEvent);
	}

	componentDidMount() {

	}
	onUsefulLinkClick = (linkName) => {
		const gaEvent  = { category: 'quikr_pwa',action: 'quikr_pwa_useful_links',label: `quikr_pwa_useful_links_${linkName}` };
		this.pushGa(gaEvent);
	}

	onFollowUsClick = (platformName) => {
		const gaEvent  = { category: 'quikr_pwa',action: 'quikr_pwa_follow_us',label: `quikr_pwa_follow_us_${platformName}` };
		this.pushGa(gaEvent);
	}

	render(props, state) {
		return (
			<Footer>
				<h4 class="mdc-footer__heading">Useful Links</h4>
				<List links class="mdc-footer__primary-links">
					<ListItem link href="/html/about.php" onClick={e=>this.onUsefulLinkClick('about_us')} >About us</ListItem>
					<ListItem link href="/html/contact.php" onClick={e=>this.onUsefulLinkClick('contact_us')}>Contact Us</ListItem>
					<ListItem link href="/html/jobs.php" onClick={e=>this.onUsefulLinkClick('careers')}>Careers</ListItem>
					<ListItem link href="/video?id=vhS7M5IdOpI" onClick={e=>this.onUsefulLinkClick('quikr_videos')}>Quikr Videos</ListItem>
					<ListItem link href="/adsales" onClick={e=>this.onUsefulLinkClick('advertise_with_us')}>Advertise With Us</ListItem>
					<ListItem link href="http://blog.quikr.com" onClick={e=>this.onUsefulLinkClick('blog')}>Blog</ListItem>
					<ListItem link href="/help/" onClick={e=>this.onUsefulLinkClick('help')}>Help</ListItem>
					<ListItem link href="/html/premium_ads.php" onClick={e=>this.onUsefulLinkClick('premium_ads')}>Premium Ads</ListItem>
				</List>

				<div class="mdc-footer__socials">
					<h4 class="mdc-footer__heading">Follow Us</h4>
					<div class="social-elements">
						<Fab
							mini icon={
								<a aria-label="Facebook" href="http://www.facebook.com/QuikrFans" target="_blank" onClick={e=>this.onFollowUsClick('facebook')} >
									<Facebook class="mdc-footer__icons" />
								</a>
							}
						/>
						<Fab
							icon={
								<a aria-label="Linkedin" href="https://www.linkedin.com/company/673276?trk=tyah&trkInfo=clickedVertical%3Acompany%2Cidx%3A2-1-4%2CtarId%3A1427871622516%2Ctas%3Aquikr" target="_blank" onClick={e=>this.onFollowUsClick('linkedin')}>
									<Linkedin class="mdc-footer__icons" />
								</a>
							}
						/>

						<Fab
							mini
							icon={
								<a aria-label="twitter" href="http://www.twitter.com/quikr" onClick={e=>this.onFollowUsClick('twitter')} target="_blank"><Twitter class="mdc-footer__icons" /></a>
							}
						/>
						<Fab
							mini
							icon={
								<a aria-label="Youtube" href="https://www.youtube.com/channel/UCpLtpHTmLXwgNMA_OXvOQew" target="_blank" onClick={e=>this.onFollowUsClick('youtube')}><Youtube class="mdc-footer__icons" /></a>
							}
						/>
					</div>
				</div>
				<p class="mdc-footer__copyright">Copyright &copy; 2008-{state.currentYear} Quikr India Private Limited</p>
			</Footer>

		);
	}
}

export { FooterToolbar as Footer };

export default showOrHide(FooterToolbar);



// WEBPACK FOOTER //
// ../q-components/components/footer/index.js